module.exports = __webpack_public_path__ + "static/media/t-rowe-price-logo-b.226815f0.png";